module.exports = __webpack_public_path__ + "img/logo.eed3117a.png";